import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Empty,Card } from "antd";

import {
  CheckCircleOutlined,
  CrownOutlined,
  CreditCardOutlined,
  CalendarOutlined,
  DashboardOutlined
} from "@ant-design/icons";
import "./nujobsSuperadmin.scss";

import superUseStatsStore from "../../store/superuser.store";
import SuperAdminPriceTableSelectable from "../SuperAdminPriceTableSelectable";
import CertificateAddModal from "../certificateAddModal";
import NuJobsBuyEmployersPlans from "../nujobsBuyEmployersPlans";
import { SUBSCRIPTION_TABLE_COLUMNS_WIDTH_NU_JOBS } from "../../helper/tablewidthcontants";
import NuJobsHowToRenew from "../nujobsSuperadminHowToRenew";


const planListTable = [
    "Select",
    "Sr. No.",
    "Plan Name",  
    "Product",
    "Trial Period",
    "No of Users",
    "No of Resumes",
    "No of JDs/Post",
    "Vendor Connect",
    "Q Plan Price",
    "HY Plan Price",
    "Y Plan Price", 
    "Additional User Price" ,  
    "Additional Resumes Price",    
];


const historySubscriptionTable = [
    "Select",
    "Sr. No.",
    "Plan Name", 
    "No of JDs",
    "Additional JDs",
    "No of Users",
    "Additional Users",
    "Type", 
    "Status",
    "Duration",
    "Start Date",
    "End Date",
    "Due Amount",
    "Payment Status",
    "Payment Date",
    "Bank Name",
    "Reference Number"    
];

export default function NuJobsSuperAdmin() {
    const [currentView, setCurrentView] = useState("mysubscription");
    const [enablePricing, setEnablePricing] = useState(true);
    const moment = require('moment');
    const { getSuperAdminInfo,superAdminInfo} = superUseStatsStore();
  const [certificateModalOpen, setCertificateModalOpen] = useState(false);
    useEffect(() => {
       getSuperAdminInfo("All");
    }, []);
 

    const getSubType =(status)=>{
        const version_array = status.split('_')
        if(version_array[0] === "trial"){return "TRIAL"}
        if(version_array[0] === "subscription"){return "SUBSCRIPTION"}     
    }

    const getPlanID =(idx)=>{
        if(superAdminInfo?.subscriptionstats === null){
            return superAdminInfo?.freestats?.[idx].shistory?.[0].subid
        }   
        if(superAdminInfo?.freestats === null){
            return superAdminInfo?.subscriptionstats?.[idx].shistory?.[0].subid
        }  
    }
    const getEndDate =(idx)=>{
        if(superAdminInfo?.subscriptionstats === null){
            return superAdminInfo?.freestats?.[idx].shistory?.[0].enddate
        }   
        if(superAdminInfo?.freestats === null){
            return superAdminInfo?.subscriptionstats?.[idx].shistory?.[0].enddate
        }  
    }
    const getStartDate =(idx)=>{
        if(superAdminInfo?.subscriptionstats === null){
            return superAdminInfo?.freestats?.[idx].shistory?.[0].startdate
        }   
        if(superAdminInfo?.freestats === null){
            return superAdminInfo?.subscriptionstats?.[idx].shistory?.[0].startdate
        }  
    }

    
    const convertDateFromTStoDate = (ts) =>{
        if(ts !=""){
            var date = new Date(ts * 1000);
            return moment(date).format('YYYY.MM.DD');

        }else{
            return ""
        }
        
    }

    const planListData = superAdminInfo?.planlist?.map((plan, idx) => {
        return {
            select:"",
            id: idx+1,
            name: plan.planname,
            product: plan.product===""?"QHRFlow":plan.product,
            trialperiod: plan.trialperiod,
            maxusers: plan.maxusers,
            maxresumes: plan.maxresumes,
            maxjds: plan.maxjds,
            vendorconnect: plan.vendorconnect,
            quarterly: plan.quarterly,            
            hyearly: plan.hyearly,
            yearly: plan.yearly,
            addonuseramt: plan.addonuseramt,
            addonresumeamt: plan.addonresumeamt,           
        };
    });    

    
    const getSubscriptionDuration = () => {
         var stype = getSubType(superAdminInfo?.subscriptionstats?.[0]?.shistory?.[0].status)
        var sduration = stype==="TRIAL"?superAdminInfo?.subscriptionstats?.[0].shistory?.[0].trialperiod + " Days" :superAdminInfo?.subscriptionstats?.[0]?.shistory?.[0].duration + " Months"
        return sduration
    };

    const mySubscriptionListData = superAdminInfo?.subscriptionstats?.map((stats, idx) => {
        var stype = getSubType(stats?.shistory?.[0].status)
        var sduration = stype==="TRIAL"?stats?.shistory?.[0].trialperiod :stats?.shistory?.[0].duration + " Months"
        return {
            id:idx+1,
            type:stype,
            planname: stats?.shistory?.[0].planname,
            substatus: stats?.shistory?.[0].status,
            duration: sduration,
            startdate: convertDateFromTStoDate(stats?.shistory?.[0].startdate),
            enddate: convertDateFromTStoDate(stats?.shistory?.[0].enddate)
        };
    });  
    const getSubDisplayStatus =(status)=>{
        if(status === "trial_none"){return "-"}
        if(status === "trial_inactive"){return "INACTIVE"}
        if(status === "trial_active"){return "ACTIVE"}
        if(status === "trial_expired"){return "EXPIRED"}   
        if(status === "trial_stop"){return "STOP"}
        if(status === "trial_activation_in_progress"){return "ACTIVATION IN PROGRESS"}    
        if(status === "subscription_none"){return "-"}
        if(status === "subscription_inactive"){return "INACTIVE"}
        if(status === "subscription_new_req"){return "NEW REQ "}
        if(status === "subscription_configured"){return "CONFIGURED"}
        if(status === "subscription_active"){return "ACTIVE"}
        if(status === "subscription_expired"){return "EXPIRED"}
        if(status === "subscription_stopped"){return "STOPPED"} 
        if(status === "subscription_aborted"){return "ABORTED"} 
        if(status === "subscription_activation_in_progress"){return "ACTIVATION IN PROGRESS"}  
        if(status === "payment_none"){return "Not Applicable"}
        if(status === "payment_done"){return "Payment Done"}
        if(status === "payment_req"){return "Payment Pending"}

    }
    const historySubscriptionListData = superAdminInfo?.subscriptionstats[0]?.shistory?.map((history, idx) => {
        //console.log("stats",stats)

        var stype = getSubType(history.status)
        var sduration = stype==="TRIAL"?history.trialperiod :history.duration + " Months"
        return {
            select:"",
            id:idx+1,
            planname: history.planname,
            numJDS:history.planconfig?.numjds,
            additionalJDS:0,
            numUsers:history.planconfig?.numusers, 
            additionalUsers:0,           
            type:stype,
            substatus: getSubDisplayStatus(history.status),
            duration: sduration,
            startdate: convertDateFromTStoDate(history.startdate),
            enddate: convertDateFromTStoDate(history.enddate),
            planamount:history.paymentamount===0?"Free":history.paymentamount,
            paymentstatus: getSubDisplayStatus(history.paymentstatus),
            paymentdate: history.paymentdate,
            bankname:"",
            referencenumber: history.paymentmethod,
        };
    });   



  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    return (

        <div className="nujobssuperadmin-summary-wrapper">
      <CertificateAddModal
        certificateModalOpen={certificateModalOpen}
        setCertificateModalOpen={setCertificateModalOpen}
        companyName={userDetails.organization}
        email={userDetails.email}
      />
            {currentView !== "profile" && (
                <>
                    <div className="section-header">
                        <h3 className="title">SuperAdmin Details</h3>
            <Button
              style={{
                height: "40px",
                fontWeight: "600",
                marginBottom: "50px",
              }}
              htmlType="submit"
              onClick={() => setCertificateModalOpen(true)}
            >
              Upload Document
            </Button>
                    </div>
                    <div className="jd-summary-buttons-wrapper">
                        <Button
                            className={`jd-summary-btn ${
                                currentView === "mysubscription" && "jd-summary-btn-active"
                            }`}
                            onClick={() => setCurrentView("mysubscription")}
                        >
                            My Subscription
                        </Button>                        
                        {
                            enablePricing?
                            <>
                                <Button
                                    className={`jd-summary-btn ${
                                        currentView === "plans" && "jd-summary-btn-active"
                                    }`}
                                    onClick={() => setCurrentView("plans")}
                                >
                                   Buy/Renew Plans
                                </Button>                                                               
                            </>
                            :<></>
                        } 
                        <Button
                            className={`jd-summary-btn ${
                                currentView === "howtobuy" && "jd-summary-btn-active"
                            }`}
                            onClick={() => setCurrentView("howtobuy")}
                        >
                            How to Renew/Buy Plans
                        </Button>                                                                                                                             
                    </div>
                </>
            )}
            {superAdminInfo !== null? (
                <div className="jd-summary-wrapper">
                    {
                    currentView === "plans" ? (
                           <NuJobsBuyEmployersPlans
                                isClickable
                                titleList={planListTable}
                                isEditField = {true}
                                data={planListData}
                                setCurrentView={setCurrentView}
                                currentView = {currentView}                                
                          />                                                                                                                      
                    ): currentView === "howtobuy" ? ( 
                        <NuJobsHowToRenew />
                    ):(
                        <div className="superadmin-subs-wrapper ">
                          <div className="superadmin-subs-cards-wrapper">

                            <Card     title={
                                        <div className="subs-card-title">
                                            <CheckCircleOutlined />
                                            <span>Subscription Status</span>
                                        </div>
                                        } variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {getSubDisplayStatus(superAdminInfo?.subscriptionstats?.[0]?.shistory?.[0].status)}
                            </Card>
                            <Card     title={
                                        <div className="subs-card-title">
                                            <CrownOutlined />
                                            <span>Plan Name</span>
                                        </div>
                                        } variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {superAdminInfo?.subscriptionstats?.[0]?.shistory?.at(-1)?.planname}
                            </Card>
                            <Card     title={
                                            <div className="subs-card-title">
                                                <CreditCardOutlined />
                                                <span>Subscription Mode</span>
                                            </div>
                                            } variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {getSubType(superAdminInfo?.subscriptionstats?.[0]?.shistory?.at(-1)?.status)}
                            </Card>
                                <Card title={
                                            <div className="subs-card-title">
                                                <DashboardOutlined />
                                                <span>Duration</span>
                                            </div>
                                            }  variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {getSubscriptionDuration()}
                            </Card>
                            <Card title={
                                            <div className="subs-card-title">
                                                <CalendarOutlined />
                                                <span>Start Date</span>
                                            </div>
                                            } variant="borderless" style={{ backgroundColor: "#cee3f8" }}>
                                {convertDateFromTStoDate(superAdminInfo?.subscriptionstats?.[0].shistory?.at(-1)?.startdate)}
                            </Card>
                                <Card title={
                                            <div className="subs-card-title">
                                                <CalendarOutlined />
                                                <span>End Date</span>
                                            </div>
                                            } variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {convertDateFromTStoDate(superAdminInfo?.subscriptionstats?.[0].shistory?.at(-1)?.enddate)}
                            </Card>
                          </div>

                          <div className="superadmin-subs-heading" style={{ marginTop: "60px" }} > Subscription History</div>
                          <div className="superadmin-subs-history"> 
                                <SuperAdminPriceTableSelectable
                                        titleList={historySubscriptionTable}
                                        data={historySubscriptionListData}
                                        setCurrentView={setCurrentView}
                                        currentView = {currentView}
                                        columnWidth={SUBSCRIPTION_TABLE_COLUMNS_WIDTH_NU_JOBS}
                                />
                          </div>    
                         <div style={{ marginTop: "60px" }} > </div>
                                                 
                        </div>                                                                                             
                    )}
                    
                </div>
            ) : (
                <Empty style={{ margin: "60px" }} >
                    <h4>SuperAdmin Dash Board</h4>
                </Empty>
            )}         
        </div>
    );
}
